import { Component, Input, OnInit } from '@angular/core';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ModalController, Platform } from '@ionic/angular';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Device } from '../../../models/Device';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { AppuserZoneUpdRequest } from '../../../services/SicorService/RequestObject/AppuserZoneUpdRequest';
import { Installation } from '../../../models/Installation';
import { StorageService } from '../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { ProfileInstallationService } from '../../../services/commons/profile-installation.service';


@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss'],
})
export class DeviceDetailComponent implements OnInit {

  public deviceDetailForm: FormGroup;
  public userName: any;
  public currentInstallation: Installation = new Installation();
  @Input('device') device: Device;

  constructor( 
    private translate: TranslateConfigService,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    private gvs: GlobalVariablesService,
    private storage: StorageService,
    private profileInsService: ProfileInstallationService,
    public platform: Platform
  ) {}

  async ngOnInit() {
    this.deviceDetailForm = this.formBuilder.group({
      device_name: new FormControl(this.device.zdescr, [Validators.required]),
    });
    this.userName = this.gvs.user.userName;
    this.currentInstallation = this.gvs.currentInstallation;
  }
    
  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Detalle Dispositivo', contentGroup: 'Perfil Instalacion'});
  }

  dismiss(confirm: boolean, result: boolean) {
    this.modalCtrl.dismiss({ confirm: confirm, result: result});
  }

  onSubmit(){
    this.dismiss(false, false);
    this.deviceDetailForm = this.gms.checkAllowedCharacters(this.deviceDetailForm);
    if (this.deviceDetailForm.controls['device_name'].value != '' && this.deviceDetailForm.controls['device_name'].value != this.device.zdescr){
      this.changeZoneName();
    }
  }

  async changeZoneName(){
    await this.gms.loading();
    let paramsRequest: AppuserZoneUpdRequest = new AppuserZoneUpdRequest (this.userName, this.currentInstallation.s_ins, this.device.zix, this.deviceDetailForm.controls['device_name'].value);
    const response = await this.profileInsService.changeZoneName(paramsRequest);
    if (response === undefined){
      this.modalCtrl.dismiss(false,'','loadSpinner');
      return;
    }
    else if(response){
      this.modalCtrl.dismiss(false,'','loadSpinner');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), this.translate.getTranslate('PROFILE.tabs.devices.zoneUpdOK'),
      'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }else{
      this.modalCtrl.dismiss(false,'','loadSpinner');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), this.translate.getTranslate('PROFILE.tabs.devices.zoneUpdKO'),
      'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  editTitle(){
    var titleInput = document.getElementById('titleInput');
    titleInput.focus();
  }

}
